import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../axiosConfig';

export const fetchOnboardingProgress = createAsyncThunk('onboarding/fetchProgress', async () => {
  const res = await axios.get(`/merchant/onboarding/progress`);
  return res.data;
});

export const completeStep = createAsyncThunk('onboarding/completeStep', async ({ stepId, data }) => {
  const res = await axios.post(`/merchant/onboarding/complete/${stepId}`, { data });
  return res.data;
});

export const getNextStep = createAsyncThunk('onboarding/getNext', async () => {
  const res = await axios.get(`/merchant/onboarding/next`);
  return res.data;
});

const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState: { 
    steps: [], 
    progress: null, 
    nextStep: null,
    status: 'idle', 
    error: null 
  },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchOnboardingProgress.pending, (s) => { s.status = 'loading'; })
     .addCase(fetchOnboardingProgress.fulfilled, (s, a) => { 
       s.status = 'succeeded'; 
       s.steps = a.payload.steps; 
       s.progress = a.payload.progress; 
     })
     .addCase(fetchOnboardingProgress.rejected, (s, a) => { s.status = 'failed'; s.error = a.error.message; })
     .addCase(completeStep.fulfilled, (s) => { s.status = 'idle'; })
     .addCase(getNextStep.fulfilled, (s, a) => { s.nextStep = a.payload.nextStep; });
  }
});

export default onboardingSlice.reducer;
